import { render } from "./HomePage.vue?vue&type=template&id=2183b0e6&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=2183b0e6&lang=scss&scoped=true"
import "./HomePage.vue?vue&type=style&index=1&id=2183b0e6&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2183b0e6"]])

export default __exports__